import React, { ReactNode } from 'react';
import { Container, Text } from '@soluto-design/react';
import Media, { MediaProps } from '../../molecules/Media';
import cls from '@soluto-design/styles/cls';

export interface BannerSectionProps {
    title: string;
    titleTag?: string;
    text?: string;
    media?: MediaProps['media'];
    children?: string | ReactNode;
    brochureImage?: MediaProps['media'];
}

export default function BannerSection({
    title,
    titleTag = 'h3',
    text,
    media,
    children,
    brochureImage,
}: BannerSectionProps) {
    return (
        <section className="my-xxxl">
            <Container>
                <div className="relative row overflow-hidden rounded-large">
                    {media && (
                        <Media
                            media={media}
                            {...(!media.isImage && { autoPlay: true })}
                            layout="fill"
                        />
                    )}
                    <div
                        className={cls(
                            'col-span-full lg:col-span-5 lg:col-start-4 xl:col-span-7 xl:col-start-6 hd:col-span-6 hd:col-start-7 flex flex-col p-24 md:p-40 xl:p-48 m-24 md:m-64 lg:ml-0 xl:m-96 xl:ml-0 bg-background-primary rounded-medium z-10',
                            brochureImage &&
                                'xl:!col-span-full xl:ml-96 xl:flex-row gap-xxl',
                        )}>
                        {!!brochureImage && (
                            <div
                                className={cls(
                                    'rounded-medium p-[10%] h-[231px] md:h-[368px] xl:h-full bg-base-100 flex items-center justify-center lg:hidden xl:flex',
                                )}>
                                <Media
                                    className="rounded-medium !w-[135px] md:!w-[182px] xl:!w-[232px]"
                                    media={brochureImage}
                                    layout="responsive"
                                />
                            </div>
                        )}
                        {(!!title || !!text || !!children) && (
                            <div>
                                {!!title && (
                                    <Text
                                        isHtml
                                        component={titleTag as any}
                                        className="text-h300 text-text-primary [&>em]:italic [&>i]:italic">
                                        {title}
                                    </Text>
                                )}
                                {!!text && (
                                    <Text
                                        isHtml
                                        component="div"
                                        className="text-b300 text-text-secondary pt-lg">
                                        {text}
                                    </Text>
                                )}
                                {!!children && <>{children}</>}
                            </div>
                        )}
                    </div>
                </div>
            </Container>
        </section>
    );
}
